import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Currency from '../../../../components/Currency';
import { DEFAULT_CURRENCY } from '../../../../config';

import useStyles from '../../../../components/MUI/SummaryWrapper/Details/makeStyles';

const ContractDetailsSection = ({
  range,
  riskAmount,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={2} direction="row">
        <Grid item xs={8} className={classes.label}>
          <Typography>{t('contract.summaryFields.startDate')}</Typography>
        </Grid>
        <Grid item xs={4} className={classes.valueContainer}>
          {/* eslint-disable-next-line no-restricted-globals */}
          {range.start && !isNaN(range.start) ? format(range.start, 'dd/MM/yyyy') : '-'}
        </Grid>
      </Grid>
      <Grid container spacing={2} direction="row">
        <Grid item xs={8} className={classes.label}>
          <Typography>{t('contract.summaryFields.endDate')}</Typography>
        </Grid>
        <Grid item xs={4} className={classes.valueContainer}>
          {/* eslint-disable-next-line no-restricted-globals */}
          {range.end && !isNaN(range.end) ? format(range.end, 'dd/MM/yyyy') : '-'}
        </Grid>
      </Grid>
      <Grid container spacing={2} direction="row">
        <Grid item xs={7} className={classes.label}>
          <Typography>{t('contract.summaryFields.riskAmount')}</Typography>
        </Grid>
        <Grid item xs={5} className={classes.valueContainer}>
          <Currency
            value={riskAmount}
            withSymbol
            currency={DEFAULT_CURRENCY}
          />
        </Grid>
      </Grid>
    </>
  );
};

ContractDetailsSection.propTypes = {
  range: PropTypes.shape({
    start: PropTypes.instanceOf(Date),
    end: PropTypes.instanceOf(Date),
  }).isRequired,
  riskAmount: PropTypes.number,
};

ContractDetailsSection.defaultProps = {
  riskAmount: 0,
};

export default ContractDetailsSection;
